/**
 * @param preferenceCenterFormData {{[p: string]: string} | PreferenceCenterFormData}
 * @return {PreferenceCenterMarketoFormData}
 */
module.exports = function convertPreferenceCenterFormDataToMarketoFormData(preferenceCenterFormData) {
    return {
        Email: preferenceCenterFormData.email,
        PF_Product_News_Email__c: preferenceCenterFormData.productNewsEmail ? "yes" : "",
        PF_Events_Activate_Conference_Email__c: preferenceCenterFormData.eventsActivateConferenceEmail ? "yes" : "",
        PF_Webinars_Resources_Email__c: preferenceCenterFormData.webinarsResourcesEmail ? "yes" : "",
        PF_Newsletters_Email__c: preferenceCenterFormData.newslettersEmail ? "yes" : "",
        PF_Blog_Email__c: preferenceCenterFormData.blogEmail ? "yes" : "",
        SMS_Checkbox__c: preferenceCenterFormData.marketingSMSOptIn ? "yes" : "",
        Country: "United State",
        MobilePhone: preferenceCenterFormData.marketingSMSOptIn ? preferenceCenterFormData.phoneNumber : undefined,
    };
}
